module.exports = __webpack_public_path__ + "img/contact_list_bj.48ac61ec.png";